import qs from 'query-string';
import http from '@services/http';

export const getVICSChildren = data => {
  const query = data ? `?${qs.stringify(data, { arrayFormat: 'bracket' })}` : '';

  return http.get(`/profiles/VICSChildren${query}`);
};